import type OwaWorkload from 'owa-workloads/lib/store/schema/OwaWorkload';
import { type BootResourceName } from '../resources';

export const getResourcesForWorkload = (workload: OwaWorkload): BootResourceName => {
    let resource = null;

    switch (workload) {
        case 2:
            resource = 'cbjs';
            break;
        case 1:
            resource = 'mbjs';
            break;
        case 4:
            resource = 'pbjs';
    }

    return resource;
};
